import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { GALLERY, GYM } from "@/lib/gymData";

export const Gallery = () => {
  const images = GALLERY;

  return (
    <section id="gallery" data-testid="gallery-section" className="relative bg-[#0d0d0d] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-12 flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-xl">
            <p className="text-blaze text-xs uppercase tracking-[0.3em] mb-4">Our Gym Gallery</p>
            <h2 className="font-display text-white text-5xl sm:text-6xl xl:text-7xl leading-[0.9] tracking-tight">
              INSIDE THE POINT
            </h2>
          </div>
          <a
            href={GYM.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="gallery-instagram-link"
            className="inline-flex items-center gap-2 text-neutral-300 hover:text-blaze transition-colors text-sm uppercase tracking-[0.15em]"
          >
            <Instagram size={18} /> @{GYM.instagram}
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          {images.map((src, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 2) * 0.1 }}
              data-testid={`gallery-image-${i}`}
              className="group relative overflow-hidden border border-white/10 aspect-[4/3]"
            >
              <img
                src={src}
                alt={`Fitness Point Gym ${i + 1}`}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-blaze/0 group-hover:bg-blaze/10 transition-colors" />
            </motion.div>
          ))}
        </div>
        <p className="mt-6 text-neutral-500 text-xs tracking-wide">
          Follow us on Instagram for daily updates.
        </p>
      </div>
    </section>
  );
};
